/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lifeScenario/interests': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M10 17.35l-1.45-1.32C3.4 11.36 0 9.27 0 5.5 0 2.41 2.42 0 5.5 0 7.24 0 8.91.81 10 2.08 11.09.81 12.76 0 14.5 0 17.58 0 20 2.41 20 5.5c0 3.77-3.4 5.86-8.55 10.53L10 17.35z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
